import PrivateRoute from './PrivateRoute';
export * from './PrivateRoute';
export default PrivateRoute;
